import { render, staticRenderFns } from "./Paquetes.vue?vue&type=template&id=0d2b7a30&scoped=true"
import script from "./Paquetes.vue?vue&type=script&lang=js"
export * from "./Paquetes.vue?vue&type=script&lang=js"
import style0 from "./Paquetes.vue?vue&type=style&index=0&id=0d2b7a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2b7a30",
  null
  
)

export default component.exports